import React from "react";
import { Form } from "react-bootstrap";
import { DynamicIcon } from "lucide-react/dynamic";

export default class ITabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: props.selected || 0,
    };
  }

  icon = (name, size = 22, strokeWidth = 1.2) => {
    return (
      <DynamicIcon
        name={name || "info"}
        size={size}
        strokeWidth={strokeWidth}
        className="pb-1"
      />
    );
  };

  _setContent = (index) => {
    this.setState({
      selected: index,
    });
  };

  render() {
    const { navItems, container } = this.props;
    const { selected } = this.state;

    // 🔥 Always derive content from props (no stale state)
    const content = navItems[selected]?.component;

    return (
      <Form as="section" className="iws-tab-nav">
        {/* Tabs */}
        <Form
          as="div"
          className="tabs d-flex align-items-start justify-content-start flex-wrap"
        >
          {navItems.map((item, index) => (
            <Form
              as="div"
              role="button"
              key={"tab-" + index}
              onClick={() => this._setContent(index)}
              className={`py-1 my-1 mx-3 tab ${
                index === selected ? "tab-active" : ""
              }`}
            >
              {this.icon(item?.icon)} {item.title}
            </Form>
          ))}
        </Form>

        {/* Content */}
        <Form
          as="div"
          className="tab-content m-4"
          id={`container-${container}`}
        >
          {content}
        </Form>
      </Form>
    );
  }
}